@if (data) {
  @for(epoch of data; track epoch) {
  <div class="font-poppins text-gray-800">
    <ul class="list-disc pl-6 space-y-3">
      <li class="list-item">
        <h3 class="text-xl font-bold">Epoch Name: {{ epoch.type }}</h3>
        @for(visit of epoch.visits; track visit) {
        <div class="mb-4 ml-2">
          <ul class="[list-style-type:circle] pl-6 pt-2">
            <li class="list-item text-lg font-semibold mb-2">Visit Type : {{ visit.type }}</li>
            <ul class="[list-style-type:square] pl-6 space-y-1.5">
              <li><strong>Contact Mode :</strong> {{ visit.contact_mode }}</li>
              <li><strong>Visit Timing :</strong> {{ visit.visit_timing.type }}</li>
              <li><strong>Inp Timing :</strong> {{ visit.inp_timing.type }}</li>
            </ul>
          </ul>
        </div>
        }
      </li>
    </ul>
  </div>
  }
}